import {
  EmailInput,
  LargePrimaryButton,
  LargeSecondaryButton,
  Validator,
} from "@worthy-npm/clarity";
import { sendCode } from "actions/logIn";
import GA from "lib/ga";
import I18n from "lib/i18n/i18n";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isMobile } from "../../helpers/ApplicationHelper";
import Validators from "../../lib/validators";
import Popup from "./popup";
import UserActions from "lib/userActions";

const NUMBER_OF_CODE_DIGITS = 6;

class OtpPopup extends Popup {
  constructor(props) {
    super(props);

    this.state = {
      digits: [],
      codeSent: false,
      codeValue: "",
      email: props.useAdoEmail ? props.adoEmail : "",
      isValid: props.useAdoEmail ? true : false,
    };
    this.intercom = null;
    this.digitsRefs = [];
    for (let index = 0; index < NUMBER_OF_CODE_DIGITS; index++) {
      this.state.digits.push(null);
      this.digitsRefs.push(React.createRef());
    }
  }

  static initPopup(props = {}) {
    props.stopAnimation ? props.stopAnimation() : null;
    Popup.initPopup.call(this, props);
  }

  componentDidMount() {
    if (isMobile()) {
      this.intercom =
        document.querySelector(".intercom-launcher") ||
        document.querySelector(".intercom-app");
    }
    if (this.intercom) {
      this.intercom.style.display = "none";
    }
  }

  componentWillUnmount() {
    if (this.intercom) {
      this.intercom.style.display = "initial";
    }
  }

  _onPopupClose() {
    if (this.props.stopAnimation) {
      this.props.stopAnimation();
    }
  }

  _hide = () => {
    super._hide();
  };

  onVerify = async (stopAnimation) => {
    const { userActionId } = this.props;
    const res = await this.props.onVerify({
      otp_code: this.state.codeValue,
      email: this.state.email,
      request_id: this.state.requestId,
      medium: this.state.medium,
    });

    UserActions.myAccount(
      "Shipback - OTP verification success",
      userActionId,
      "Item"
    );

    if (!res.error) {
      this._hide();
    } else {
      const errors = {
        400: res._data.error,
        401: res._data.error,
        500: "Something went wrong. Please try later",
      };
      this.setError(errors[res._errorCodesList[0]]);
    }
    stopAnimation();
  };

  setError(error) {
    const { userActionId } = this.props;

    UserActions.myAccount(
      "Shipback - OTP verification failed",
      userActionId,
      "Item"
    );

    this.setState({ validationMessage: error });
  }

  requestCode(medium, stopAnimation) {
    const { userActionId } = this.props;

    medium = medium || this.state.medium;
    // is valid?
    if (!this.state.isValid) {
      let validator = new Validator(this.state.email);
      validator.isEmail().isEmailEmpty();
      this.setError(validator.validationMessage);
      if (stopAnimation) stopAnimation();
      return;
    }
    UserActions.myAccount(
      "Shipback - OTP verification code requested",
      userActionId,
      "Item"
    );

    this.setState({ validationMessage: undefined });
    this.props
      .sendCode({
        medium,
        email: this.state.email,
        requestId: this.state.requestId,
      })
      .then((res) => {
        if (res.payload.status === 200) {
          if (res.payload.data.prettyError) {
            this.setError(res.payload.data.prettyError);
          } else {
            this.setState({
              codeSent: true,
              medium,
              requestId: res.payload.data.request_id,
              phone: `***-***-${res.payload.data.phone}`,
            });
          }
        } else {
          const errors = {
            404: "Email doesn't exist in our system. <a href='/register' class='blue'>Register</a>",
            500: "Something went wrong. Please try later.",
          };
          this.setError(errors[res.payload._errorCodesList[0]]);
        }
      })
      .finally(stopAnimation);
  }

  loginFormScreen(topText, boldText, inputRenderer, buttonsRenderer) {
    return (
      <div className="login-form-area">
        <div className="login-form-top-text">
          {topText} <span>{boldText}</span>
        </div>
        <div className="login-form-input-area">{inputRenderer()}</div>
        <div className="login-form-buttons">{buttonsRenderer()}</div>
      </div>
    );
  }

  emailInputRenderer() {
    const { emailDisabled } = this.props;
    return (
      <EmailInput
        disabled={emailDisabled}
        label="Email"
        initialValue={this.state.email || ""}
        change={(value) => {
          this.setState({
            email: value,
            isValid: Validators.validateEmail(value),
            validationMessage: null,
          });
        }}
        overrideCSS={{
          font: "300 16px Roboto",
          focus: { borderColor: "#2D5DEC" },
          hover: { borderColor: "#2D5DEC" },
        }}
        forceValidationMessage={this.state.validationMessage}
        autoFocus
      />
    );
  }

  sendCodeButtonsRenderer() {
    const buttonOverride = {
      borderRadius: "3px",
      width: "100%",
      padding: "11px 22px 12px",
      border: "none",
    };
    return (
      <div>
        <LargePrimaryButton
          text="Send code to my email"
          click={(stopAnimation) => {
            this.requestCode("email", stopAnimation);
          }}
          overrideWrapperCSS={{ display: "block", marginBottom: "12px" }}
          overrideCSS={buttonOverride}
        />
        <LargeSecondaryButton
          text="Send code to my phone"
          click={(stopAnimation) => {
            this.requestCode("sms", stopAnimation);
          }}
          overrideWrapperCSS={{ display: "block" }}
          overrideCSS={buttonOverride}
        />
      </div>
    );
  }

  codeScreenButtonsRenderer() {
    const { codeValue } = this.state;

    const buttonOverride = {
      borderRadius: "3px",
      width: "100%",
      padding: "11px 22px 12px",
      font: "500 16px Roboto",
    };

    return (
      <div>
        <LargePrimaryButton
          text="Verify account"
          disabled={codeValue.length < NUMBER_OF_CODE_DIGITS}
          click={this.onVerify}
          overrideWrapperCSS={{ display: "block", marginBottom: "12px" }}
          overrideCSS={buttonOverride}
        />
        <LargeSecondaryButton
          text="Resend code"
          click={(stopAnimation) => {
            GA.LoginFormEvents.resendCodeClicked();
            this.setState(
              { codeSent: false, validationMessage: null },
              stopAnimation
            );
          }}
          overrideWrapperCSS={{ display: "block" }}
          overrideCSS={buttonOverride}
        />
      </div>
    );
  }

  emailScreen() {
    return this.loginFormScreen(
      I18n.getString("logIn::emailScreen::verify"),
      I18n.getString("logIn::emailScreen::verifyBoldText"),
      this.emailInputRenderer.bind(this),
      this.sendCodeButtonsRenderer.bind(this)
    );
  }

  codeScreen() {
    return this.loginFormScreen(
      I18n.getString("logIn::codeScreen::topText"),
      this.state.medium === "email" ? this.state.email : this.state.phone,
      this.codeInputRenderer.bind(this),
      this.codeScreenButtonsRenderer.bind(this)
    );
  }

  codeInputRenderer() {
    const updateCode = (value, index) => {
      const digits = [...this.state.digits];
      digits[index] = value;
      const tCode = digits.filter((c) => !!c).join("");
      this.setState({ codeValue: tCode, digits, validationMessage: null });
      if (value.length) {
        if (index < NUMBER_OF_CODE_DIGITS - 1) {
          this.digitsRefs[index + 1].current.focus();
        } else {
          this.digitsRefs[index].current.blur();
        }
      }
    };
    const inputs = [];
    let { validationMessage } = this.state;
    for (let i = 0; i < NUMBER_OF_CODE_DIGITS; i++) {
      inputs.push(
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]"
          ref={this.digitsRefs[i]}
          maxLength={1}
          autoFocus={i === 0}
          key={i}
          name={`${i}`}
          className={`code-6-digits ${
            validationMessage ? "border-error shake-error" : ""
          }`}
          onChange={(e) => updateCode(e.target.value, i)}
          onFocus={(e) => e.target.select()}
        />
      );
    }
    return (
      <div className="align-center">
        {inputs}
        <div
          className={
            "login-error" + (this.state.validationMessage ? "" : " hidden")
          }
        >
          {this.state.validationMessage}
        </div>
      </div>
    );
  }

  title = () => {
    return null;
  };

  footer = () => {
    return null;
  };

  content = () => {
    return (
      <div className="login-container-otp">
        <div className="login-box">
          <div className="login-form-title">Verify your Account</div>
          {this.state.codeSent ? this.codeScreen() : this.emailScreen()}
        </div>
      </div>
    );
  };
}

OtpPopup.propTypes = {
  emailDisabled: PropTypes.bool,
  useAdoEmail: PropTypes.bool,
  onSendCode: PropTypes.func,
  onVerifyCode: PropTypes.func,
  // uses from redux state
  email: PropTypes.string,
  phone: PropTypes.string,
};

OtpPopup.defaultProps = {
  emailDisabled: true,
  useAdoEmail: true,
  popupClassName: "otp-popup",
  single: true,
  modal: true,
  onPopupClose: function () {
    this._onPopupClose();
  },
};

const mapStateToProps = (state) => ({
  adoEmail: state.ADO.user.email,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ sendCode }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpPopup);
